import { Btn } from '../furniture';

/**
 * The one way a truncated list asks to be lengthened, wherever it appears: the
 * same words, the same button. Renders nothing while the list already fits.
 * `noun` names the parts — "holdings", "stocks", "trades" — so the label says
 * what the rest are. Stops the click so a row it sits inside does not toggle.
 */
export function ShowAll({ total, shown, all, onToggle, noun = 'rows' }) {
  if (!all && shown >= total) return null;
  return (
    <Btn onClick={(e) => { e.stopPropagation(); onToggle(); }}>
      {all ? 'Show fewer' : `Show all ${total} ${noun}`}
    </Btn>
  );
}
